"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const useInputDebounce = input => {
  const ref = _react.default.useRef();
  const [shouldRun, setShouldRun] = _react.default.useState(false);
  _react.default.useEffect(() => {
    if (!ref.current) {
      ref.current = true;
      return undefined;
    }
    const timer = setTimeout(() => {
      return setShouldRun(true);
    }, 550);
    return () => {
      clearTimeout(timer);
      setShouldRun(false);
    };
  }, [input]);
  return shouldRun;
};
var _default = useInputDebounce;
exports.default = _default;